import React, { useState } from 'react';
import { supabase } from '../lib/supabase';

export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [notice, setNotice]     = useState('');
  const [loading, setLoading]   = useState(false);
  const [sending, setSending]   = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    setNotice('');

    const { error } = await supabase.auth.signInWithPassword({ email, password });

    if (error) {
      setError(error.message);
      setLoading(false);
    }
  }

  // Sends a recovery link, which lands on SetPassword. This is the fallback
  // for an instructor whose onboarding setup link expired before they got a
  // free moment — recovery tokens are short-lived and they teach all day.
  async function handleReset() {
    if (!email) {
      setError('Enter your email address first, then tap this again.');
      return;
    }
    setSending(true);
    setError('');
    setNotice('');

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin
    });

    setSending(false);
    // Deliberately the same message either way: confirming whether an address
    // has an account would let anyone probe for valid instructor emails.
    if (error && !/rate|limit|too many/i.test(error.message)) {
      setNotice('If that email has an account, a link is on its way. Check spam too.');
      return;
    }
    setNotice(error
      ? 'Too many requests just now — wait a minute and try again.'
      : 'Link sent. Check your email (and your spam folder) for a link to set your password.');
  }

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', background: '#0f0f0f', fontFamily: 'system-ui, sans-serif'
    }}>
      <div style={{
        background: '#1a1a1a', border: '1px solid #2a2a2a', borderRadius: 12,
        padding: '40px', width: '100%', maxWidth: 380
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: '#fff', marginBottom: 4 }}>
            Visionry
          </div>
          <div style={{ fontSize: 14, color: '#888' }}>Admin Dashboard</div>
        </div>

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 13, color: '#888', marginBottom: 6 }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={{
                width: '100%', padding: '10px 12px', background: '#0f0f0f',
                border: '1px solid #2a2a2a', borderRadius: 8, color: '#fff',
                fontSize: 14, outline: 'none', boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', fontSize: 13, color: '#888', marginBottom: 6 }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              style={{
                width: '100%', padding: '10px 12px', background: '#0f0f0f',
                border: '1px solid #2a2a2a', borderRadius: 8, color: '#fff',
                fontSize: 14, outline: 'none', boxSizing: 'border-box'
              }}
            />
          </div>

          {error && (
            <div style={{
              background: '#2a1a1a', border: '1px solid #ff4444', borderRadius: 8,
              padding: '10px 12px', color: '#ff6666', fontSize: 13, marginBottom: 16
            }}>
              {error}
            </div>
          )}

          {notice && (
            <div style={{
              background: '#10434a', border: '1px solid #2f7d8a', borderRadius: 8,
              padding: '10px 12px', color: '#7fd0dc', fontSize: 13, marginBottom: 16
            }}>
              {notice}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%', padding: '12px', background: '#6c47ff',
              border: 'none', borderRadius: 8, color: '#fff', fontSize: 15,
              fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1
            }}
          >
            {loading ? 'Signing in...' : 'Sign in'}
          </button>

          <button
            type="button"
            onClick={handleReset}
            disabled={sending}
            style={{
              width: '100%', marginTop: 14, background: 'none', border: 'none',
              color: '#888', fontSize: 13, textDecoration: 'underline',
              cursor: sending ? 'default' : 'pointer', padding: 4
            }}
          >
            {sending ? 'Sending…' : 'Forgot password? Set a new one'}
          </button>
        </form>
      </div>
    </div>
  );
}